import { render, staticRenderFns } from "./EntityAccountDetails.vue?vue&type=template&id=2fffad3e&"
import script from "./EntityAccountDetails.vue?vue&type=script&lang=js&"
export * from "./EntityAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fffad3e')) {
      api.createRecord('2fffad3e', component.options)
    } else {
      api.reload('2fffad3e', component.options)
    }
    module.hot.accept("./EntityAccountDetails.vue?vue&type=template&id=2fffad3e&", function () {
      api.rerender('2fffad3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/entityAccount/EntityAccountDetails.vue"
export default component.exports